<div *ngIf="passwordControl && touchedOrDirty">
  <div
    [ngClass]="{
      'text-success': passwordValid,
      'text-danger': !passwordValid
    }"
  >
    Seguridad: {{ passwordValid ? 'Fuerte' : 'Débil' }}
  </div>

  <ul class="list-unstyled small">
    <li
      [ngClass]="{
        'text-success': !errors.minLength,
        'text-danger': errors.minLength
      }"
    >
      1- Mínimo 6 caracteres
    </li>

    <li
      [ngClass]="{
        'text-success': !errors.uppercase,
        'text-danger': errors.uppercase
      }"
    >
      2- Al menos una letra mayúscula
    </li>

    <li
      [ngClass]="{
        'text-success': !errors.lowercase,
        'text-danger': errors.lowercase
      }"
    >
      3- Al menos una letra minúscula
    </li>

    <li
      [ngClass]="{
        'text-success': !errors.number,
        'text-danger': errors.number
      }"
    >
      4- Al menos un número
    </li>

    <li
      [ngClass]="{
        'text-success': !errors.special,
        'text-danger': errors.special
      }"
    >
      5- Al menos un carácter especial (#$%&?@$. _-)
    </li>
  </ul>

  <div
    class="text-danger small"
    *ngIf="showMismatch"
  >
    El campo Contraseña no coincide con su confirmación
  </div>
</div>
